import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { sameUserIdControlDirective } from '../same-userid-control.directive';

@NgModule({
  declarations: [sameUserIdControlDirective],
  imports: [CommonModule],
  exports: [sameUserIdControlDirective],
})
export class SameUserIdControlDirectiveModule {}
